// extracted by mini-css-extract-plugin
module.exports = {"modal_header":"AdditionalInfoModal_modal_header__IbN_K","modal_dialog":"AdditionalInfoModal_modal_dialog__eKCF3"};